import React from 'react';
import { 
  HelpCircle, 
  Ruler, 
  Grid, 
  Layers, 
  CheckSquare, 
  Clock, 
  BetweenHorizontalStart, 
  PenTool 
} from 'lucide-react';

/**
 * Компонент с полезными советами по ремонту
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Ruler,
      title: 'Точные замеры',
      description: 'Измеряйте расстояния от стены до стены, а не от плинтуса до плинтуса. Учитывайте ниши, выступы и другие особенности.'
    },
    {
      icon: Grid,
      title: 'Расчет материалов',
      description: 'Всегда добавляйте запас: для напольных покрытий 5-7%, для обоев и краски 10-15%, для плитки 10%.'
    },
    {
      icon: Layers,
      title: 'Выбор материалов',
      description: 'Для влажных помещений выбирайте водостойкие материалы. Для детских комнат – экологичные и безопасные.'
    },
    {
      icon: CheckSquare,
      title: 'Подготовка поверхностей',
      description: 'Стены и потолки должны быть чистыми, ровными и сухими перед отделкой для лучшего результата.'
    },
    {
      icon: Clock,
      title: 'Планирование работ',
      description: 'Строительные работы всегда занимают дольше, чем планируется. Добавляйте 20-30% к расчетному времени.'
    },
    {
      icon: BetweenHorizontalStart,
      title: 'Инструменты и техника',
      description: 'Качественные инструменты экономят время и улучшают результат. Не экономьте на основных инструментах.'
    },
    {
      icon: PenTool,
      title: 'Дизайн интерьера',
      description: 'Светлые цвета визуально расширяют пространство. Для маленьких помещений выбирайте светлые оттенки.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-fuchsia-500" />
        Советы по ремонту
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-fuchsia-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-fuchsia-50 dark:bg-fuchsia-900/20 border border-fuchsia-100 dark:border-fuchsia-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-fuchsia-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-fuchsia-700 dark:text-fuchsia-300 mb-2">
              Получить профессиональную консультацию
            </h4>
            <p className="text-xs text-fuchsia-600 dark:text-fuchsia-400 mb-3">
              Нужна помощь с выбором материалов или планировкой? Проконсультируйтесь со специалистом для оптимальных решений.
            </p>
            <button className="w-full py-1.5 text-xs bg-fuchsia-500 text-white rounded hover:bg-fuchsia-600 transition-colors">
              Найти дизайнера
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;